import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_menu",
  ref: "menuModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_menu_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { style: {"width":"100%"} }
const _hoisted_10 = { class: "modal-footer" }
const _hoisted_11 = { class: "btn-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_popover = _resolveDirective("popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.title), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_form, {
            size: _ctx.size,
            ref: "formRef",
            "label-width": "150px",
            model: _ctx.dataForm,
            rules: _ctx.rules,
            "validate-on-rule-change": false
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_form_item, {
                  label: "Tên chức năng :",
                  prop: "name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.dataForm.cTenChucNang,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dataForm.cTenChucNang) = $event)),
                      size: _ctx.size
                    }, null, 8, ["modelValue", "size"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Loại",
                  prop: "type"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.dataForm.nLoai,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dataForm.nLoai) = $event)),
                      size: _ctx.size
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio, {
                          key: "0",
                          label: 1,
                          value: 1
                        }, {
                          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                            _createTextVNode("Menu gốc", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, {
                          key: "1",
                          label: 2,
                          value: 2
                        }, {
                          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                            _createTextVNode("Menu", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, {
                          key: "2",
                          label: 3,
                          value: 3
                        }, {
                          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                            _createTextVNode("Button", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, {
                          key: "3",
                          label: 4,
                          value: 4
                        }, {
                          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                            _createTextVNode("Liên kết ngoài", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "size"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Menu cha :",
                  prop: "parentName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_popover, {
                      ref: "popover",
                      trigger: "click",
                      "popper-style": "width:'fit-content'; max-height:400px; overflow:auto",
                      style: {}
                    }, {
                      reference: _withCtx(() => [
                        _withDirectives(_createVNode(_component_el_input, {
                          size: _ctx.size,
                          readonly: true,
                          style: {"cursor":"pointer"},
                          modelValue: _ctx.dataForm.parentName,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dataForm.parentName) = $event))
                        }, null, 8, ["size", "modelValue"]), [
                          [_directive_popover, void 0, "popover"]
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_tree, {
                          ref: "tree",
                          data: _ctx.table,
                          props: _ctx.treeProp,
                          onNodeClick: _ctx.handleNodeClick,
                          "render-content": _ctx.renderContent
                        }, null, 8, ["data", "props", "onNodeClick", "render-content"])
                      ]),
                      _: 1
                    }, 512)
                  ]),
                  _: 1
                }),
                (_ctx.dataForm.nLoai == 2 || _ctx.dataForm.nLoai == 4)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "Đường dẫn :",
                      prop: "cUrl"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.dataForm.cUrl,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dataForm.cUrl) = $event)),
                          size: _ctx.size
                        }, null, 8, ["modelValue", "size"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, {
                  label: "Quyền :",
                  prop: "cQuyen",
                  rules: 
                  _ctx.dataForm.nLoai == 3
                    ? [
                        {
                          required: true,
                          message: 'Xin vui lòng nhập quyền',
                          trigger: 'blur',
                        },
                      ]
                    : null
                
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.dataForm.cQuyen,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataForm.cQuyen) = $event)),
                      size: _ctx.size
                    }, null, 8, ["modelValue", "size"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_el_form_item, {
                  label: "Icon :",
                  prop: "cIcon"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.dataForm.cIcon,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataForm.cIcon) = $event)),
                      size: _ctx.size
                    }, null, 8, ["modelValue", "size"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Thứ tự :",
                  prop: "nThuTu"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.dataForm.nThuTu,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dataForm.nThuTu) = $event)),
                      size: _ctx.size
                    }, null, 8, ["modelValue", "size"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["size", "model", "rules"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_button, {
              size: _ctx.size,
              type: "primary",
              onClick: _ctx.handleSave
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode("Xác nhận", -1)
              ]))]),
              _: 1
            }, 8, ["size", "onClick"]),
            _createVNode(_component_el_button, {
              size: _ctx.size,
              type: "danger",
              onClick: _ctx.handleClose
            }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createTextVNode("Thoát", -1)
              ]))]),
              _: 1
            }, 8, ["size", "onClick"])
          ])
        ])
      ])
    ])
  ], 512))
}